import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ModalContext } from 'App';

import UpdateDiscountAndPenaltyModal from '../modal/UpdateDiscountAndPenaltyModal'

import * as actions from '../actions';
import * as c from '../constants';


const RPTBillingSettingsSmartCity = ({
  permissions,
  getDiscountAndPenalty,
  discountAndPenaltyList,
  updating,
}) => {
  const setModal = useContext(ModalContext);

  const getList = () => {
    getDiscountAndPenalty({})
  }

  useEffect(() => {
    getList()    
  }, [])

  const handleUpdateModal = item => {
    setModal({  
      isOpen: true,
      content: <UpdateDiscountAndPenaltyModal type="UPDATE" item={item} id={_.get(item, "id")} getDiscountAndPenalty={getDiscountAndPenalty} />,
      title: 'Update Discount & Penalty',
      modalSize: 'modal-lg',
      modalContentSize: 'custom-size'
    });
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-2 my-3 pl-2">
        <h2 className="mt-1 header-title font-weight-bold text-dark">
          Real Property Tax Settings
        </h2>
      </div>
      {/* Discount and Penalty */}
      <div className="">
        <h3 className="h3 discount-and-penalty-title mb-4 py-2 cms-text-primary d-inline-block">
          Discount and Penalty
        </h3>

        {/* Discount & Penalty */}
        {_.isEmpty(discountAndPenaltyList) && <div>No Available Records</div>}
        {discountAndPenaltyList?.map(item => {
          return (
            <div key={item.id} className=" p-4 billing-container">
              <div className="d-flex justify-content-between w-100">
                <h2 className="h3 mt-1 header-title font-weight-bold text-dark d-inline-block">
                  Discount & Penalty
                </h2>
                {Acl(permissions, ['VIEW RPTAX SETTINGS DISCOUNT AND PENALTY']) && (
                  <div>
                    {updating && <span className="fas fa-spin fa-spinner mr-3" />}
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                      onClick={() => handleUpdateModal(item)}
                    >
                      {updating ? "Updating" : "Update"}
                    </button>
                  </div>
                )}
              </div>
              <hr className="w-100" />
              <div className="mb-3 form-wrapper-alternate-bg">
                <InputDisplayTemplate title="Year" dataItem={_.get(item, "attributes.year") || "--"} />
                <InputDisplayTemplate title="Additional Monthly Penalty Percentage" dataItem={_.get(item, "attributes.monthly_penalty_percentage") || "--"} />
                <InputDisplayTemplate title="December (current year) Discount Percentage" dataItem={_.get(item, "attributes.advance_discount_percentage") || "--"} />
                <InputDisplayTemplate title="January Discount Percentage" dataItem={_.get(item, "attributes.january_discount_percentage") || "--"} />
                <InputDisplayTemplate title="February Discount Percentage" dataItem={_.get(item, "attributes.february_discount_percentage") || "--"} />
                <InputDisplayTemplate title="March Discount Percentage" dataItem={_.get(item, "attributes.march_discount_percentage") || "--"} />
                <InputDisplayTemplate title="Maximum Monthly Penalty Percentage" dataItem={_.get(item, "attributes.maximum_penalty_percentage") || "--"} />
                {/* 
                  <InputDisplayTemplate title="Date Before Penalty Start" dataItem="01/01/2023" />
                  <InputDisplayTemplate title="Last Date with Discount" dataItem="12/31/2022" />
                */}
              </div>
            </div>
          )
        })}
      </div>
      <div className="w-100 mt-4" />
    </>
  );
};

const InputDisplayTemplate = ({
  title,
  dataItem,
  isImage,
  imgClassName,
  containerClassName,
  isAddress,
  children,
}) => (
  <>
    <div className="row mx-1 py-2 ">
      <div className={`${containerClassName} col-6`}>
        <div className="span-title2 px-2 font-weight-bold">{title}</div>
      </div>
      {isAddress ? (
        <div className={`${containerClassName} col-6`}>
          <div className="text-uppercase span-input2">{children || "N/A"}</div>
        </div>
      ) : (
        <div className={`${containerClassName} col-6`}>
          {!isImage ? (
            <div className="text-uppercase span-input2">
              {dataItem || "N/A"}
            </div>
          ) : (
            <img className={`${imgClassName}`} src={dataItem} alt="" />
          )}
        </div>
      )}
    </div>
  </>
);

InputDisplayTemplate.defaultProps = {
  dataItem: "",
  title: "",
  isImage: false,
  imgClassName: "",
  containerClassName: "",
  // hasExistingPinnedLocation: "",
  isAddress: false,
  children: "",
};

InputDisplayTemplate.propTypes = {
  dataItem: PropTypes.node,
  title: PropTypes.string,
  isImage: PropTypes.bool,
  imgClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  isAddress: PropTypes.bool,
  children: PropTypes.node,
};


RPTBillingSettingsSmartCity.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  getDiscountAndPenalty: PropTypes.instanceOf(Function).isRequired,
  discountAndPenaltyList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  discountAndPenaltyList: _.get(api, `${c.GET_DISCOUNT_AND_PENALTY}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_DISCOUNT_AND_PENALTY) > -1,
});


const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RPTBillingSettingsSmartCity);
